"use client";

import React from "react";
import { ArrowRight, ShieldCheck, Snowflake } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Action() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: shouldReduceMotion ? 1 : 0,
      scale: shouldReduceMotion ? 1 : 0.98,
      y: shouldReduceMotion ? 0 : 16
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  const featureItems = ["Southern California & Las Vegas Area", "Rental terms provided with quote."];
  return <section id="final-call-to-action" data-nav="light" className="relative w-full border-y border-border bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} className="relative overflow-hidden rounded-2xl border border-border bg-card p-6 text-center shadow-sm sm:p-12 md:p-16">
          {/* Subtle background decoration accent */}
          <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent/20 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-16 -left-16 h-64 w-64 rounded-full bg-primary/10 blur-3xl" />

          {/* Operational Status Pill */}
          <div className="inline-flex items-center gap-2 rounded-full border border-border bg-muted/60 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider text-foreground">
            <span className="relative flex size-2">
              <span className="absolute inline-flex size-full animate-ping rounded-full bg-primary opacity-75" />
              <span className="relative inline-flex size-2 rounded-full bg-primary" />
            </span>
            <span>Request a quote</span>
          </div>

          {/* Section Headline */}
          <h2 className="mx-auto mt-6 max-w-3xl font-default text-3xl font-bold tracking-tight text-card-foreground sm:text-4xl md:text-5xl">
            Ready to Request a Quote?
          </h2>

          {/* Supporting Copy */}
          <p className="mx-auto mt-4 max-w-2xl text-base text-muted-foreground sm:text-lg">Request a quote for Mobile Refrigerated or Freezer trailer rental availability in Southern California or our listed Las Vegas-area communities.</p>

          {/* Feature highlights strip */}
          <div className="mx-auto mt-8 flex flex-wrap items-center justify-center gap-4 text-xs font-medium text-muted-foreground sm:gap-6 sm:text-sm">
            {featureItems.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-1.5">
                <ShieldCheck className="size-4 shrink-0 text-primary" />
                <span>{feature}</span>
              </div>)}
          </div>

          {/* CTA Cluster */}
          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
            <Button size="lg" className="w-full sm:w-auto font-semibold px-8 py-6 text-base transition-colors" asChild>
              <Link to="/ContactRequestAQuotePage">
                <span>Request a Quote</span>
                <ArrowRight className="size-4 ml-1" />
              </Link>
            </Button>

            <Button variant="secondary" size="lg" asChild className="w-full sm:w-auto font-semibold px-8 py-6 text-base">
              <a href="tel:2135218821">
                <span>213-521-8821</span>
              </a>
            </Button>
          </div>

          {/* Response Note */}
          <div className="mt-6 flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
            <Snowflake className="size-3.5 shrink-0 text-muted-foreground" />
            <span>Availability provided with quote.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}